import React from "react";
import { connect } from "react-redux";

class NumberOfItemsInTable extends React.Component {
  render() {
    const { meta, resultMeta } = this.props;
    const from = meta.get("offset") + 1;
    const to = meta.get("offset") + meta.get("limit") >
      (resultMeta && resultMeta.all)
      ? resultMeta && resultMeta.all
      : meta.get("offset") + meta.get("limit");
    const all = resultMeta && resultMeta.all;
    return (
      <div className="info">
        Pokazuję{" "}
        {from}
        {" "}do{" "}
        {to}
        {" "}z{" "}
        {all ? all : <i className=" fa fa-circle-o-notch fa-spin" />}
        {" "}wpisów
      </div>
    );
  }
}

export default NumberOfItemsInTable;



// WEBPACK FOOTER //
// ./src/browser/components/Table/NumberOfItemsInTable.js